import React, { useState, useEffect } from "react";
import { Card, CardHeader, CardBody, Label, Row, Col, Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import Loader from "../../Components/Common/Loader";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { getInitialsfromString } from "../../helpers/api_helper";
import { NEWDISCOUNT } from "../../helpers/data_helper";

// import {
//   currencyFormatWithAlert,
//   currencyFormatWithoutDecimal,
//   numberFormat,
//   currencyFormat,
//   getPercentageWithAlert,
//   getPercentageWithAlertV2,
// } from "../../helpers/api_helper";

const TeamMemberPerformance
  = (
    {
      currency,
      mealPeriod, leftFilter, discountCodes, serveList
    }
  ) => {
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    const [listOfTeamPerformance, setListOfTeamPerformance] = useState([]);

    useEffect(() => {
      setLoading(true)
      postDataAPI({
        serviceName: NEWDISCOUNT.serviceName,
        op: NEWDISCOUNT.op_discount_dashboard_server,
        leftFilter: leftFilter,
        mealPeriod: mealPeriod,
        // page: 0,
        server_id: serveList,
        discount_id: discountCodes,
      }).then((response) => {
        setLoading(false);
        if (response.status === "ok") {
          setListOfTeamPerformance(response?.data?.data)
        }
      });

    }, [mealPeriod, leftFilter, discountCodes, serveList]);



    return (
      <Row>
        <Card>
          <CardHeader className="ps-0 d-flex justify-content-between align-items-center border-0">
            <div className="d-flex align-items-start">
              <div className={`icon-box rounded bg-danger text-white`}>
                <i className="ri-team-line "></i>
              </div>
              <div className="ps-2">
                <h4 className="card-title mb-1">Team Member Performance</h4>
                <p className="text-muted mb-0">
                  Individual discount contributions and efficiency vs team</p>
              </div>
            </div>
          </CardHeader>
          {loading && <Loader />}
          <CardBody className={`p-0 row ${loading ? "opacity-0" : ''}`}>
            {listOfTeamPerformance
              ?.sort((a, b) => b.discount_given - a.discount_given) // sort descending
              ?.slice(0, 4).map((item, index) => (
                <Col xl={3} key={index} className="d-flex">
                  <Card className="performance-card w-100">
                    <CardBody className="d-flex flex-column justify-content-between">
                      <div>
                        <div className="d-flex justify-content-start mb-2">
                          <div className="performance-card-shortname d-flex fs-18 p-2 align-items-center justify-content-center rounded-circle me-2 text-white fw-semibold">
                            {getInitialsfromString(item?.team_member)}
                          </div>
                          <div className="text-start mb-3">
                            <h6 className="mb-1 fs-16 fw-semibold">{item?.team_member}</h6>
                            <div className="text-muted small">{item?.role}</div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Discounts Given</span>
                          <span className="text-danger fs-16 fw-semibold">
                            {item?.discount_given}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Discounted Value</span>
                          <span className="text-success fs-16 fw-semibold">
                            ${Number(item?.total_value).toFixed(0)}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-muted">Efficiency</span>
                          <span
                            className={`${item?.efficiency < 75
                              ? "perfornamce-efficiency-low"
                              : item?.efficiency < 90
                                ? "perfornamce-efficiency-medium"
                                : "perfornamce-efficiency-high"
                              } fw-1200 py-1 px-2 rounded-pill `}
                          >
                            <i className="ri-star-line" /> {Number(item?.efficiency).toFixed(2)} %
                          </span>
                        </div>
                      </div>
                      <hr />

                      <div>
                        <p className="text-muted my-1">
                          Overall discount contribution {Number(item?.team_contribution).toFixed(2)}%
                        </p>
                        <div className="performance-card-progrssbar w-100 rounded-pill">
                          <div
                            className="discount-bar rounded-pill"
                            style={{
                              width: `${Number(item?.team_contribution).toFixed(2)}%`,
                            }}
                          ></div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}

            <Col xl={3} className="d-flex">
              <Card className="performance-card w-100">
                <CardBody className="d-flex flex-column justify-content-center">
                  <div
                    className="text-center p-3 border rounded-3 btn cursor-pointer w-100"
                    style={{ backgroundColor: '#f8f9fc' }}
                    onClick={toggle}
                  >
                    <p className="text-muted mb-0">+</p>
                    <p className="text-dark mb-0 fw-semibold">View 4 More Members</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </CardBody>

        </Card>

        <Modal isOpen={isOpen} toggle={toggle} centered size="xl">
          <ModalHeader toggle={toggle}>Detailed Team Member Performance</ModalHeader>
          <ModalBody>
            <div style={{ overflow: 'auto', maxHeight: '500px' }} >

              <Table borderless responsive>
                <thead>
                  <tr>
                    <th scope="row" className="text-muted px-2">
                      <span className="fs-16 w-100">
                        Team Member
                      </span>
                    </th>
                    <th scope="row" className="text-muted px-2">
                      <span className="fs-14">
                        Role
                      </span>
                    </th>
                    <th scope="row" className="text-muted text-center px-2">
                      <span className="fs-14">
                        Discounts Given
                      </span>
                    </th>
                    <th scope="row" className="text-muted text-center px-2">
                      <span className="fs-14">
                        Total Value
                      </span>
                    </th>
                    <th scope="row" className="text-muted text-center px-2">
                      <span className="fs-14">
                        Efficiency
                      </span>
                    </th>
                    <th scope="row" className="text-muted text-center">
                      <span className="fs-14">
                        Team Contribution
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {listOfTeamPerformance?.map((item, index) => (
                    <tr key={index}>
                      <td className="d-flex align-items-center fs-14" style={{ width: '250px' }}>
                        <div className="performance-card-shortname d-flex fs-16 p-2 align-items-center justify-content-center rounded-circle me-2 text-white fw-semibold" >
                          {getInitialsfromString(item?.team_member)}
                        </div>
                        <span>{item?.team_member}</span>
                      </td>
                      <td className="text-muted q">
                        <span className="fs-14">{item?.role}</span>

                      </td>
                      <td className="text-center" style={{ color: "red", width: '180px' }}>
                        <span className="text-danger fs-16 fw-semibold">
                          {item?.discount_given}

                        </span>
                      </td>
                      <td className="text-center" style={{ color: "teal", width: '120px' }}>
                        <span className="text-success fs-16 fw-semibold">
                          ${Number(item?.total_value).toFixed(0)}
                        </span>
                      </td>
                      <td className="text-center" style={{ width: '120px' }}>
                        <span
                          className={`d-flex justify-content-center gap-1 align-items-center ${Number(item?.efficiency).toFixed(2) < 75
                            ? "perfornamce-efficiency-low"
                            : Number(item?.efficiency).toFixed(2) < 90
                              ? "perfornamce-efficiency-medium"
                              : "perfornamce-efficiency-high"
                            } fw-1200 py-1 px-2 rounded-pill`}
                        >
                          <i className="ri-star-line" /> <span>{Number(item?.efficiency).toFixed(2)}</span><span>%</span>
                        </span>
                      </td>
                      <td className="text-muted text-center" style={{ width: '200px' }}>
                        <span className="fs-16 fw-semibold">{Number(item?.team_contribution).toFixed(2)}%</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </ModalBody>
        </Modal>
      </Row>
    );
  };

export default TeamMemberPerformance;
